/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Biodiversidade() {
  return (
    <PaginasEspecificas posicao="23" endereco="/biologia" materia="Biologia" />
  );
}

export default Biodiversidade;
